module.exports = __webpack_public_path__ + "static/media/3DPPA9.58afac6c.jpg";